import { MealType } from 'common/MealTypeUtils';
import { QueryParams } from 'common/urls/QueryParams';
import { chain, isNil, omitBy } from 'lodash';
import {
  DishFirstExploreSegmentShefFragment,
  DishFirstFoodItemPreviewFragment,
  DishFirstFoodItemsSegmentFragment,
  DishFirstPreviewFilterFragment,
  DishFirstSegmentFilter,
} from 'src/gqlReactTypings.generated.d';
import { QueryParamsUpdates } from 'src/pages/consumer/explore/useExploreUrl';

export const getQueryParamsFromSeeAllFilter = (
  seeAllFilter: DishFirstPreviewFilterFragment
): QueryParamsUpdates<DishFirstSegmentFilter> =>
  omitBy(
    {
      [QueryParams.DATE]: seeAllFilter.availabilityDates,
      [QueryParams.CUISINE_FILTER]: seeAllFilter.cuisineFilters,
      [QueryParams.DIETARY_FILTER]: seeAllFilter.dietaryFilters,
      [QueryParams.DISH_TYPE_FILTER]: seeAllFilter.dishTypeFilters,
      [QueryParams.ECO_FILTER]: seeAllFilter.isEcoFriendlyPackaging,
      [QueryParams.MIN_RATING_FILTER]: seeAllFilter.minDishRating,
      [QueryParams.PRICE_LEVEL_FILTER]: seeAllFilter.priceLevelFilters,
      [QueryParams.PROTEIN_FILTER]: seeAllFilter.proteinFilters,
      [QueryParams.SPICE_LEVEL_FILTER]: seeAllFilter.spiceLevelFilters,
    },
    isNil
  );

export const createEmptyFoodItemArray = (): DishFirstFoodItemPreviewFragment[] => [];

export const emptyItemsByMealType = {
  [MealType.Main]: createEmptyFoodItemArray(),
  [MealType.Side]: createEmptyFoodItemArray(),
  [MealType.Appetizer]: createEmptyFoodItemArray(),
  [MealType.Dessert]: createEmptyFoodItemArray(),
  [MealType.Kids]: createEmptyFoodItemArray(),
  [MealType.Beverage]: createEmptyFoodItemArray(),
};

export const sortItemsByMealType = (foodItems: DishFirstFoodItemPreviewFragment[]) =>
  foodItems.reduce((acc, cur) => {
    if (cur.foodType) {
      if (acc[cur.foodType]) {
        return { ...acc, [cur.foodType]: [...acc[cur.foodType], cur] };
      }
      return acc;
    }
    return acc;
  }, emptyItemsByMealType);

export const isFoodItemSegment = (segment): segment is DishFirstFoodItemsSegmentFragment =>
  segment.__typename === 'ExploreFoodItemsSegment';

export const foodItemsHasMultipleMealTypes = (foodItems: DishFirstFoodItemPreviewFragment[]) => {
  const sortedItems = sortItemsByMealType(foodItems);
  return (
    chain(sortedItems)
      .pickBy((items) => items.length > 0)
      .keys()
      .value().length > 1
  );
};

export const isExploreSegmentShef = (item): item is DishFirstExploreSegmentShefFragment =>
  // eslint-disable-next-line no-underscore-dangle -- Field is from Apollo.
  item.__typename === 'ExploreSegmentShef';
